import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    margin: '0 auto',
    background: theme.palette.secondary.main,
    color: theme.palette.secondary.main,
    padding: theme.spacing(4),
    paddingBottom: 0,
    position: 'relative',
    zIndex: 1,
  },
  bgImageContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
  },
  bgImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    position: 'absolute',
    opacity: 0.2,
    top: 0,
  },
  introContainer: {
    marginBottom: 60,
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      alignItems: 'flex-end',
    },
    color: theme.palette.opaque.white,
  },
  heading: {
    ...theme.typography.h2,
    marginBottom: 20,
    marginTop: 20,
    [theme.breakpoints.up('md')]: {
      marginTop: 36,
    },
  },
  supportiveCopy: {
    maxWidth: 732,
    marginBottom: 10,
    [theme.breakpoints.up('md')]: {
      marginBottom: 0,
    },
  },
  ctaContainer: {
    flex: 1,
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
  },
  flexMediaContainer: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },
  },
  featuredVideoContainer: {
    width: 'calc(100% / 3 * 1.75)',
    minWidth: 0,
  },
  infoCardsContainer: {
    padding: 0,
    margin: 0,
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
}))

export default useStyles
